// eslint-disable-next-line import/no-named-as-default
import posthog, { type PostHog } from "posthog-js";

import { POSTHOG_HOST, POSTHOG_KEY } from "./env";
import { scrubSessionProperties } from "./scrubSessionQuery";

export const posthogClient = posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  // why: before_send runs after session props are merged, so $session_entry_url still carries the handoff URL that was on location.href at init
  before_send: (event) => {
    if (event == null) return event;
    scrubSessionProperties(event.properties);
    return event;
  },
  session_recording: {
    maskAllInputs: true,
    maskInputFn: (text, element) => {
      if (
        element instanceof HTMLInputElement &&
        // Mask password fields and the text version when toggling password visibility
        (element.type === "password" ||
          element.name === "password" ||
          element.id === "password" ||
          element.id === "password-input")
      ) {
        return "*".repeat(text.length);
      }
      return text;
    },
  },
}) as PostHog;

// Stamp the build mode on every event as a super-property so dev / staging /
// prod traffic can be separated in PostHog dashboards. Mirrors the backend
// `stage` field that `packages/commons-node/src/libs/posthog.ts` attaches via
// `BUILD_STAGE`.
posthogClient?.register({ stage: import.meta.env.MODE });
